import React from 'react'

function DashboardCalenderIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="92" height="92" viewBox="0 0 92 92">
            <g id="Group_96341" data-name="Group 96341" transform="translate(-1280 -132)">
                <circle id="Ellipse_1213" data-name="Ellipse 1213" cx="46" cy="46" r="46" transform="translate(1280 132)" fill="rgba(0,151,240,0.1)" />
                <g id="event_black_24dp_4_" data-name="event_black_24dp (4)" transform="translate(1299 151)">
                    <path id="Path_28492" data-name="Path 28492" d="M0,0H55V55H0Z" fill="none" />
                    <path id="Path_28493" data-name="Path 28493" d="M35.083,26.208H23.625V37.667H35.083ZM32.792,1V5.583H14.458V1H9.875V5.583H7.583a4.563,4.563,0,0,0-4.56,4.583L3,42.25a4.582,4.582,0,0,0,4.583,4.583H39.667A4.6,4.6,0,0,0,44.25,42.25V10.167a4.6,4.6,0,0,0-4.583-4.583H37.375V1Zm6.875,41.25H7.583V17.042H39.667Z" transform="translate(3.875 1.292)" fill="#1b5984" />
                </g>
            </g>
        </svg>
    )
}

export default DashboardCalenderIcon